import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import PageNavigation from './navigation/PageNavigation';
import Navbar from './navigation/Navbar';
import ScrollTop from './components/ScrollTop';
import BoookingData from './Booking/BoookingData';
import LiveChat from './Livechat/LiveChat';

function App() {
	return (
		<BrowserRouter>
			<ScrollTop />
			<Navbar />
			<PageNavigation />
			<LiveChat />
			<BoookingData />
		</BrowserRouter>
	);
}

export default App;
